import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Tooltip from 'SharedComponents/ui/Tooltip.vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { NestedLinkType } from 'SharedDir/constants/files';
import { reactive } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'NestedFolderLinkOption' },
  __name: 'NestedFolderLinkOption',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits);

const options = reactive([
  { value: NestedLinkType.none, slot: 'none' },
  { value: NestedLinkType.singleLevel, slot: 'single-level' },
]);

return (_ctx: any,_cache: any) => {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!

  return (_openBlock(), _createBlock(_component_q_btn_toggle, {
    modelValue: _unref(innerValue),
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      _unref(emitValue)
    ],
    unelevated: "",
    ripple: false,
    size: "xl",
    dense: "",
    options: options
  }, {
    none: _withCtx(() => [
      _createVNode(Tooltip, {
        icon: "app:description",
        text: "Файл будет загружен только в текущую директорию"
      })
    ]),
    "single-level": _withCtx(() => [
      _createVNode(Tooltip, {
        icon: "app:multiple-files",
        text: "Файл будет загружен в текущую директорию, и в ее дочерние (первого уровня) директории"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "options", "onUpdate:modelValue"]))
}
}

})